import { TeamMemberRole } from '@api'
import { useUnit } from 'effector-react'

import { ProfileCard } from '@/components/ui/profile-card'
import { $account } from '@/models/account.ts'
import {
  $creatorNotes,
  $creatorNotesUpdating,
  updateCreatorNotesFx,
} from '@/models/creator-notes.ts'
import { $currentCreator } from '@/models/creators.ts'
import { $ofCollectionsCount } from '@/models/of-collections-count.ts'

import { Notice } from './notice'

export const CreatorInfoContent = () => {
  const account = useUnit($account)
  const activeCreator = useUnit($currentCreator)
  const creatorNotes = useUnit($creatorNotes)
  const isUpdating = useUnit($creatorNotesUpdating)
  const stats = useUnit($ofCollectionsCount)

  const isAdminOrLeader = [TeamMemberRole.ADMIN, TeamMemberRole.LEADER].some(
    (role) => role === account?.memberRole,
  )

  return (
    <div className="bg-secondary-50 dark:bg-secondary-600 space-y-4 rounded-xl p-[18px]">
      <ProfileCard
        displayName={activeCreator?.name || ''}
        username={activeCreator?.userName || ''}
        avatarUrl={activeCreator?.avatar.croppedUrl || undefined}
        fansCount={stats?.subscribers?.active}
        followingCount={stats?.subscriptions?.active}
      />
      {activeCreator && (
        <Notice
          fanId={activeCreator?.id}
          notice={creatorNotes?.notes ?? ''}
          onUpdate={updateCreatorNotesFx}
          isUpdating={isUpdating}
          isEditAvailable={isAdminOrLeader}
        />
      )}
    </div>
  )
}
